import { CartModel } from '@/types/api'
import usePrice from '@/utils/hooks/usePrice'
import React from 'react'
import CartRow, { ColumnSettings } from '../CartRow/CartRow'

type Props = {
  cart?: CartModel
}

const CartShipping = (props: Props) => {
  const { price } = usePrice()

  const columns: ColumnSettings[] = [
    {
      label: 'Övrigt',
      value: 'Frakt',
    },
    {},
    {},
    {},
    {},
    {},
    {
      label: 'Pris',
      value: price(props.cart?.shippingPrice, true),
      textAlign: 'right',
    },
  ]

  return (
    <div>
      <CartRow
        columns={columns}
      />
    </div>
  )
}

export default CartShipping